export const colors = {
	black: "#000",
	blogFont: "#33475b",
	blue: "#6193BD",
	dark: "#424242",
	darkBlue: "#142541",
	darkBlue2: "#0A1423",
	darkBlueGrey: "#3A4F72",
	darkGray: "#CBCFD2",
	darkGreen: "#006400",
	darkRed: "#8b0000",
	deepPurple: "#301934",
	mediumPurple: "#493872",
	gray: "#9F9F9F",
	green: "#32a8a4",
	greyBlue: "#83909B",
	lightBlue: "#2D6FA7",
	mediumBlue: "#1A5B93",
	lightBrown: "#717171",
	lightGray: "#F5F5F5",
	mediumGray: "#CFCFCF",
	purple: "#64548A",
	red: "#DB6048",
	mediumRed: "#BF442D",
	transparent: "transparent",
	white: "#ffffff",
	whiteGray: "#F9F9F9",
	yellow: "#D7A44D",
	mediumYellow: "#9D6D40",
	mediumGreyTransparent: "rgba(207,207,207,0.9)",
	
};

export function resolveColor(colorField) {
	if (!colorField) {
		return "transparent";
	}
	//contentful color object
	const isObject = typeof colorField === "object";
	if (isObject) {
		return colors[colorField?.fields?.color || "transparent"];
	}
	const hexColor = Object.values(colors).find((c) => c === colorField);
	const colorsName = Object.keys(colors).find((c) => c === colorField);
	if (hexColor) {
		return hexColor;
	} else if (colorsName) {
		return colors[colorsName];
	} else return "transparent";
}

export const font = {
	Athelas: "Athelas",
	LibreBaskerville: "Libre Baskerville",
	default: '"Open Sans", Helvetica Neue, Arial, sans-serif',
};

export const duration = {
	navFade: ".3s",
	navGrow: "0.3s",
};
